import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.CatalogItemAccessPage`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  catalogItemAccessTitle: {
    id: `${scope}.catalogItemAccessTitle`,
    defaultMessage: 'Catalog item access',
  },
})
